export default __webpack_public_path__ + "static/media/c_2.03a52cab.svg";